// extracted by mini-css-extract-plugin
module.exports = {"root":"PartnersScreen_root__2YFO1","centered":"PartnersScreen_centered__34UgI","content":"PartnersScreen_content__2sgw1","grid":"PartnersScreen_grid__NO9y6","gridItem":"PartnersScreen_gridItem__1lRJD"};
    if(module.hot) {
      // 1586964018749
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  